import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import { subscriptionActions } from '../../../redux/slices/subscriptionSlice';
import { Subscription } from '../../../redux/slices/subscriptionSlice';
import { useAppDisPatch } from '../../../redux/store';
import useHttps from '../../useHttps';

const useCancelSubscription = () => {
  const request = useHttps();
  const dispatch = useAppDisPatch();
  const [loading, setLoading] = useState(false);

  const onSuccess = (response: unknown) => {
    const data = (response as SuccessHttpResponse<Subscription>).data;
    dispatch(subscriptionActions.setActiveSubscription(data));
    toast.success('Subscription canceled successfully');
  };

  const onError = (err: AxiosError<ErrorHttpResponse>) => {
    console.error('Error canceling subscription:', err?.message);
    toast.error(err?.response?.data?.message ?? 'Failed to cancel subscription');
  };

  const cancelSubscription = (reason?: string) => {
    const url: HttpConfig = {
      url: 'auth-service/subscriptions/me/cancel',
      method: 'post',
      data: { reason },
    };
    return request(url, onSuccess, setLoading, onError);
  };

  return { cancelSubscription, loading };
};

export default useCancelSubscription;
